import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react"

interface PivotRow {
  rowLabel: string
  values: Record<string, number>
  total: number
}

interface Props {
  title?: string
  rows: PivotRow[]
  columns: string[]
}

export const PivotTable: React.FC<Props> = ({ title, rows, columns }) => {
  const grandTotal = rows.reduce((sum, r) => sum + r.total, 0)
  const colTotals = columns.reduce((acc, col) => {
    acc[col] = rows.reduce((sum, r) => sum + (r.values[col] || 0), 0)
    return acc
  }, {} as Record<string, number>)

  return (
    <Box>
      {title && <Text fontWeight="semibold" mb={2} fontSize="sm">{title}</Text>}
      <Box overflowX="auto" borderWidth={1} borderRadius="md">
        <Table size="sm" variant="simple">
          <Thead bg="gray.100">
            <Tr>
              <Th></Th>
              {columns.map((col) => <Th key={col} isNumeric>{col}</Th>)}
              <Th isNumeric>Grand Total</Th>
            </Tr>
          </Thead>
          <Tbody>
            {rows.map((row) => (
              <Tr key={row.rowLabel} _hover={{ bg: "gray.50" }}>
                <Td fontWeight="medium">{row.rowLabel}</Td>
                {columns.map((col) => (
                  <Td key={col} isNumeric>{row.values[col] || 0}</Td>
                ))}
                <Td isNumeric fontWeight="bold">{row.total}</Td>
              </Tr>
            ))}
            {/* Grand Total row */}
            <Tr bg="gray.50" fontWeight="bold">
              <Td>Grand Total</Td>
              {columns.map((col) => (
                <Td key={col} isNumeric>{colTotals[col] || 0}</Td>
              ))}
              <Td isNumeric>{grandTotal}</Td>
            </Tr>
          </Tbody>
        </Table>
      </Box>
    </Box>
  )
}
